import type * as Types from '../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type VerifyCodeMutationVariables = Types.Exact<{
  code: Types.Scalars['String']['input'];
}>;


export type VerifyCodeMutationPage = { readonly __typename?: 'RootMutationType', readonly verifyCode: { readonly __typename?: 'AccountsAuthToken', readonly token: string, readonly user: { readonly __typename?: 'AccountsUser', readonly id: string, readonly uuid: string, readonly phone?: string | null, readonly roles: ReadonlyArray<Types.AccountsUserRole>, readonly insertedAt: string, readonly profile?: { readonly __typename?: 'AccountsProfile', readonly name?: string | null } | null, readonly firstCompany?: { readonly __typename?: 'AccountsCompany', readonly id: string, readonly uuid: string, readonly name: string, readonly tokens: ReadonlyArray<{ readonly __typename?: 'OauthProviderToken', readonly id: string, readonly provider: Types.OauthProvider }> } | null } } };


export const VerifyCodeDocument = gql`
    mutation VerifyCode($code: String!) {
  verifyCode(code: $code) {
    token
    user {
      id
      uuid
      phone
      roles
      insertedAt
      profile {
        name
      }
      firstCompany {
        id
        uuid
        name
        tokens {
          id
          provider
        }
      }
    }
  }
}
    `;
export type VerifyCodeMutationFn = Apollo.MutationFunction<VerifyCodeMutationPage, VerifyCodeMutationVariables>;

/**
 * __useVerifyCodeMutation__
 *
 * To run a mutation, you first call `useVerifyCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyCodeMutation, { data, loading, error }] = useVerifyCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useVerifyCodeMutation(baseOptions?: Apollo.MutationHookOptions<VerifyCodeMutationPage, VerifyCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyCodeMutationPage, VerifyCodeMutationVariables>(VerifyCodeDocument, options);
      }
export type VerifyCodeMutationHookResult = ReturnType<typeof useVerifyCodeMutation>;
export type VerifyCodeMutationResult = Apollo.MutationResult<VerifyCodeMutationPage>;
export type VerifyCodeMutationOptions = Apollo.BaseMutationOptions<VerifyCodeMutationPage, VerifyCodeMutationVariables>;